module.exports = __webpack_public_path__ + "static/media/kw.e36d4852.svg";